<template>
  <div class="app-main-content" style="position:relative;">
    <!-- 需要在切换回来后，页面保持不变，所以使用v-show -->
    <booking-tree-grid
      v-show="view==='list'"
      ref="bookingTreeGrid"
      :context="context"
      :is-query="isQuery"
      @look="lookHandle"
      @edit="editHandle"
      @copy="copyHandle"
      @add="addHandle"
    />
    <booking-workspace
      v-show="view==='detail'"
      ref="bookingWorkspace"
      :parent-context="context"
      :view="view"
      @edit="editHandle"
      @copy="copyHandle"
      @add="addHandle"
      @back="backToList"
    />
    <!-- 操作模式弹窗 -->
    <air-op-type-dialog
      :visible.sync="airOpTypeDialog.visible"
      @successHandle="airOpTypeSuccessHandle"
      @cancel="airOpTypeCancelHandle"
    />
    <!--业务复制选择复制哪些信息-->
    <job-copy-window
      :visible.sync="copyDialog.visible"
      :lob="copyDialog.job.lob || ''"
      :is-master="copyDialog.job.masterFlag"
      @confirmCallBack="confirmCallBackHandler"
    />
    <job-no-rule-selector
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="doCopyJob"
    />
  </div>
</template>

<script>
import { AiBookingContext } from './aiBookingContext'
import bookingTreeGrid from './components/booking/bookingTreeGrid.vue'
import bookingWorkspace from './components/booking/bookingWorkspace.vue'
import airOpTypeDialog from './components/booking/airOPTypeDialog.vue'
import jobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import { ErrorTip } from '@/utils/class/ErrorTip'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { getUserDefaultDepartment } from '@/api/user'
import { isContractExpiredForbidCreateJob, queryJobNoRule, doCopyJob, advancedQuery } from '@/api/AirImport/aiBooking'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JumpUtil } from '@/utils/JumpUtil'
import { ACTION_ADD, SALES_CHANNEL_OCR_RECOGNITION } from '@/class/cargo/model/parameters/SystemConstants'
import { DIRECT } from '@/class/cargo/model/parameters/ImportConstants'

export default {
  name: 'AiBooking',
  components: { bookingTreeGrid, bookingWorkspace, airOpTypeDialog, jobCopyWindow, jobNoRuleSelector },
  data() {
    return {
      loading: null,
      context: new AiBookingContext(),
      view: 'list',
      airOpTypeDialog: {
        visible: false,
        promise: null,
        resolve: null,
        reject: null
      },
      copyDialog: {
        visible: false,
        job: {}
      },
      jobNoRule: {
        visible: false,
        rules: ''
      },
      isQuery: false // 根据路由参数进行高级查询
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    },
    office() {
      return this.context.office || this.$store.getters.currentOffice
    }
  },
  watch: {
    officeId: {
      async handler(newVal) {
        if (this.office.officeId !== this.officeId) {
          await this.context.prepareData()
        }
      }
    }
  },
  created() {
    this._defalutOpDepartmentMap = new Map()
  },
  mounted() {
    if (this.$route.params.code) {
      this.isQuery = true
      this.view = 'list'
      this.sopNodeAdvancedQuery()
    }
  },
  activated() {
    const params = this.$route.params
    if (params.conditions) {
      this.isQuery = true
      this.view = 'list'
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(params.conditions)
      delete params.conditions
    } else if (this.$route.params.jobNos) {
      JumpUtil.jumpToTab(advancedQuery, {}, this.$route.params, this)
    } else if (params.jobNo) {
      this.$refs.bookingWorkspace.activeTabName = this.$route.params.activeTabName || ''
      this.toDetail(params.jobNo, this.$route.params.branchId)
      delete params.jobNo
      delete params.activeTabName
    } else if (params.code) {
      if (this.$route.meta.showExtraParam) {
        this.view = 'list'
        this.$route.meta.showExtraParam = false
      }
      this.sopNodeAdvancedQuery()
    } else if (this.$route.query.jobNo) {
      this.toDetail(this.$route.query.jobNo)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    }
  },
  methods: {
    // 首页sop面板高级查询
    sopNodeAdvancedQuery() {
      const { code, subCode, name, subName, newSubNodes, etdStart, templateKey } = this.$route.params
      let jobState = this.$route.params.jobState
      jobState = jobState.split(',').map(item => { return Number(item) })
      const data = [
        {
          fieldName: 'trackingInfo._multipleState_',
          fieldType: 'trackingMultiple',
          operator: '=',
          value: {
            operator: 'and',
            value: [
              {
                code,
                name,
                details: []
              }
            ]
          }
        },
        {
          fieldName: 'job.ETD',
          fieldType: 'FIELD_DATE_RANGE',
          operator: 'RANGE',
          value: `type=date,start=${etdStart}`
        },
        {
          fieldName: 'job.JOB_STATE',
          fieldType: null,
          label: '',
          operator: 'IN',
          value: jobState
        },
        { fieldType: 'FIELD_CHECKBOX', fieldName: 'loadRelationJobs', operator: '=', value: false }
      ]
      if (subCode && subName) {
        data[0].value.value[0]['details'].push({ code: subCode, name: subName })
      } else {
        data[0].value.value[0]['details'] = newSubNodes
      }
      // Sop模板UUID
      if (templateKey) {
        data.push(
          {
            fieldName: 'job.TRACKING_TEMPLATE_UUID',
            fieldType: null,
            label: '',
            operator: '=',
            value: templateKey
          }
        )
      }
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(data)
    },
    // 查询job后跳转详情
    toDetail(jobNo, branchId) {
      const params = {
        conditions: [new AdvancedSearchOption(null, 'job.JOB_NO', jobNo).formatObj2Json()],
        branchId: branchId || this.$store.getters.currentOfficeId,
        pageNum: 1
      }
      this.view = 'detail'
      advancedQuery(params).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length > 0) {
          this.$refs.bookingWorkspace.saveJobNos = []
          this.$refs.bookingWorkspace.removedJobNos = []
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            this.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            this.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          this.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        this.$message.error(this.$t('Message.JumpFailed'))
      })
    },
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    async editHandle(row) {
      if (row.jobState !== 0) {
        this.$message.info(this.$t('queryJob.ThisApprovalStatusAndEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new AirImportJob(row))) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.detailHandle('edit', row)
    },
    copyHandle(row) {
      if (row.masterFlag) {
        const isMasterShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob + '_MASTER') // 是否显示复制选项弹框【勾选是true不显示】
        this.copyDialog.job = row
        if (!isMasterShowView) {
          this.copyDialog.visible = true
        } else {
          this.confirmCallBackHandler()
        }
        return
      }
      if (JobUtils.checkHQ()) { return }
      if (row && row.customerId) {
        this.loading = getLoading()
        isContractExpiredForbidCreateJob(row.customerId).then(res => {
          this.loading.close()
          if (res.data) {
            this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.copyDialog.job = row
            const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob) // 是否显示复制选项弹框【勾选是true不显示】
            if (!isShowView) {
              this.copyDialog.visible = true
            } else {
              this.confirmCallBackHandler()
            }
          }
        })
      }
    },
    async confirmCallBackHandler() {
      await this.context.prepareData()
      if (this.context.config.get('UseNewJobNoRule') === '1') {
        this.loading = getLoading()
        queryJobNoRule(SystemConstants.AI.code).then(res => {
          this.ruleResultHandler(res)
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.doCopyJob()
      }
    },
    ruleResultHandler(event) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.visible = true
        this.jobNoRule.rules = rules
      } else if (rules && rules.length > 0) {
        const rule = rules[0]
        this.doCopyJob(rule)
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doCopyJob(jobNoRule) {
      const item = {}
      item.jobRule = !jobNoRule ? '' : jobNoRule.uuid
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      /* 复制哪些页签的数据 */
      const lob = this.copyDialog.job.lob
      let notMatchAgainSelect = false
      if (this.copyDialog.job.masterFlag) {
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob + '_MASTER')
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob + '_MASTER')
      } else {
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob)
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob)
      }
      item.masterFlag = this.copyDialog.job.masterFlag
      item.all = false
      item.source = 'aiBooking'
      this.loading = getLoading()
      doCopyJob(item).then(async res => {
        const oldJob = this.copyDialog.job
        const newJob = res.data
        newJob.destinationPortCode = newJob.dischargingPortCode
        newJob.salesDepartment = oldJob.salesDepartment
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'AiBooking')
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect)
        this.detailHandle('copy', newJob)
      }).finally(() => {
        this.loading.close()
      })
    },
    async addHandle(row) {
      if (JobUtils.checkHQ()) { return }
      // CARGO-48635 OCR识别 创建业务时，操作类型已经提前选好了
      if (!row.masterFlag && row.salesChannel !== SALES_CHANNEL_OCR_RECOGNITION.code) {
        try {
          row.operateType = await this.confirmOpType()
        } catch (err) {
          return
        }
      }
      // CARGO-48635 OCR识别 创建业务时，操作类型 直单时，不带分单信息
      if (row.salesChannel === SALES_CHANNEL_OCR_RECOGNITION.code) {
        if (row.operateType === DIRECT.code) {
          row.airCargoDoc = []
        }
      }
      const results = await Promise.all([
        this.getDefaultJob(),
        this.getOpDepartment()
      ])
      const defaultJob = results[0]
      const opDepartment = results[1]
      // 填充初始值
      new AirImportJob(row).fillDefaultValue()
      row.lob = 'AI'
      row.cargoType = 'GC'
      row.csr = this.context.user.userId
      row.opOffice = this.$store.getters.currentOfficeId
      if (opDepartment && Number(opDepartment.departmentId) > 0) {
        row.op = this.context.user.userId
        if (this.context.user.defaultDepId > 0 && this.context.user.defaultOfficeId === this.$store.getters.currentOfficeId) {
          row.opDepartment = this.context.user.defaultDepId
        } else {
          row.opDepartment = opDepartment.departmentId
        }
      }
      if (row.salesChannel === SALES_CHANNEL_OCR_RECOGNITION.code) {
        Object.keys(defaultJob).forEach(key => {
          // 如果 row 中没有该属性或者该属性为 undefined，则复制。优先以托书中的值为准
          if (row[key] === undefined || row[key] === null || row[key] === '') {
            row[key] = defaultJob[key]
          }
        })
      } else {
        Object.assign(row, defaultJob)
      }
      row.destinationPortCode = row.dischargingPortCode
      row.tradeTerm = row.tradeTerm || '110'
      row.freightTerm = row.freightTerm || 'FIO'
      row.taxNature = row.taxNature || 0
      if (row.masterFlag) {
        row.paymentTermHBL = row.paymentTermHBL || 'PP'
      }
      this.detailHandle('add', row)
    },
    async confirmOpType() {
      const airOpTypeDialog = this.airOpTypeDialog
      airOpTypeDialog.promise = new Promise((resolve, reject) => {
        airOpTypeDialog.resolve = resolve
        airOpTypeDialog.reject = reject
      })
      airOpTypeDialog.visible = true
      return airOpTypeDialog.promise
    },
    airOpTypeSuccessHandle(operateType) {
      this.airOpTypeDialog.resolve(operateType)
    },
    airOpTypeCancelHandle() {
      this.airOpTypeDialog.reject('cancel')
    },
    async getDefaultJob() {
      const entityDefValUtil = EntityDefaultValueUtil.getInstance()
      if (!entityDefValUtil.defaultValues) {
        await entityDefValUtil.initEntityDefaultValue()
      }
      return entityDefValUtil.airImportJob.getData()
    },
    async getOpDepartment() {
      const officeId = this.$store.getters.currentOfficeId
      let opDepartment = this._defalutOpDepartmentMap.get(officeId)
      if (!opDepartment) {
        opDepartment = await getUserDefaultDepartment({ category: 'role', shape: 'op', userId: 0, officeId }).then(res => res.data)
        this._defalutOpDepartmentMap.set(officeId, opDepartment)
      }
      return opDepartment
    },
    // 进详情处理
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.bookingWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.bookingTreeGrid.rowData
      }
      this.$refs.bookingWorkspace.saveJobNos = []
      this.$refs.bookingWorkspace.removedJobNos = []
      this.$refs.bookingWorkspace.onShow(type, rowData, row)
    },
    backToList(saveJobNos, removedJobNos) {
      if (this.$route.query.jobNo) {
        delete this.$route.query.jobNo
        delete this.$route.query.currentOfficeId
      }
      this.$refs.bookingTreeGrid.$el.style.display = 'flex'
      this.$refs.bookingWorkspace.$el.style.display = 'none'
      this.view = 'list'
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.$refs.bookingTreeGrid.toQuery(saveJobNos, removedJobNos)
      }
    }
  }
}
</script>
